import { jiraConfigAtom, userAtom } from '@/global-store';
import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

export interface JiraConfig {
  id?: number;
  orgId?: number;
  domain?: string;
  email?: string;
  /** 1 for a self-hosted Jira instance, 0 for Jira Cloud. */
  onPrem?: number;
  apiVersion?: string;
  /** Set by the API after checking the stored credentials against Jira. */
  isValid?: boolean;
  [key: string]: unknown;
}

/**
 * Loads the organisation's Jira integration config and mirrors it into
 * `jiraConfigAtom`. Returns `null` when the organisation has no integration.
 */
export function useFetchJiraConfig() {
  const user = useAtomValue(userAtom);
  const setJiraConfig = useSetAtom(jiraConfigAtom);

  const userId = user?.id;

  const query = useQuery({
    enabled: !!userId,
    queryKey: [api.jiraConfig, userId],
    queryFn: () => fetchWrapper.get<JiraConfig | null>(api.jiraConfig),
  });

  const jiraConfig = query.data;

  useEffect(() => {
    if (!jiraConfig) return;

    setJiraConfig(jiraConfig);
  }, [jiraConfig, setJiraConfig]);

  return query;
}
